import { lazy } from 'react';

const PageNotFoundComponent = lazy(() =>
    import('../../../shared/ui/PageNotFound/PageNotFoundComponent')
);
const FaqComponent = lazy(() =>
    import('../../../shared/ui/Faq/FaqComponent')
);
const MenuComponent = lazy(() =>
    import('../../../features/main/presentation/main-menu')
);
const TransactionsComponent = lazy(() =>
    import('../../../features/transaction-history/presentation/history-list')
);
const VoucherDetailComponent = lazy(() =>
    import('../../../features/products/presentation/kebutuhan-harian/components/VoucherDetail')
);


const MainRoutes = [
    {
        key: "key.root",
        path: '/',
        component: MenuComponent,
        name: ''
    },
    {
        key: "key.solusiwebappsv2",
        path: '/solusiwebappsv2',
        component: MenuComponent,
        name: 'PPOB'
    },
    {
        key: "key.transaksi",
        path: '/transaksi',
        component: TransactionsComponent,
        name: 'Riwayat Transaksi'
    },
    {
        key: "key.closed",
        path: '/solusiwebappsv2/closed',
        component: PageNotFoundComponent,
        name: ''
    },
    {
        key: "key.faq",
        path: 'faq',
        component: FaqComponent,
        name: 'FAQ'
    },
    {
        key: "key.voucherdetail",
        path: 'voucherdetail',
        component: VoucherDetailComponent,
        name: 'Voucher'
    },
]

export default MainRoutes;